import { render, staticRenderFns } from "./PersonalInfo2.vue?vue&type=template&id=1c3cc2d8"
import script from "./PersonalInfo2.vue?vue&type=script&lang=js"
export * from "./PersonalInfo2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c3cc2d8')) {
      api.createRecord('1c3cc2d8', component.options)
    } else {
      api.reload('1c3cc2d8', component.options)
    }
    module.hot.accept("./PersonalInfo2.vue?vue&type=template&id=1c3cc2d8", function () {
      api.rerender('1c3cc2d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/PersonalInfo2.vue"
export default component.exports